export { default } from './CookiesAgreement';
